import { GuardSpinner } from '@/components/GuardSpinner';
import type { PiiTrainingGuardProps } from '@/components/PiiTrainingGuard.types';
import { useAuth } from '@/contexts/AuthContext';
import { piiTrainingStatusQueryOptions } from '@/services/piiTraining/usePiiTrainingStatus';
import { statusAccountId, useStatusGate } from '@/services/statusGate/useStatusGate';

export const PiiTrainingGuard = ({ children }: PiiTrainingGuardProps) => {
  const { user, isLoading: isAuthLoading } = useAuth();
  const isBlocking = useStatusGate({
    queryOptions: piiTrainingStatusQueryOptions(statusAccountId(user)),
    enabled: !isAuthLoading && !!user,
    redirectTo: '/pii-training',
    errorMessage: 'Failed to check PII training status',
  });

  // Spinner while checking, and while redirecting so children never flash.
  if (isAuthLoading || isBlocking) return <GuardSpinner />;

  return <>{children}</>;
};
